<template>
  <v-layout row justify-center>
    <error-message ref="errorDialog" />
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container class="pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>タグを追加してください(スペース区切りで10個まで可)</h3>
              </v-flex>
              <v-flex xs12 v-if="showInputeTags">
                <v-text-field
                  @blur="blurTextfield"
                  @keydown.enter="blurTextfield"
                  v-model="tagString"
                  autofocus
                ></v-text-field>
                <v-dialog v-model="errorDialog" max-width="600">
                  <v-card>
                    <v-card-text>タグは10個まで登録できます。</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="accent" @click="errorDialog = false" flat
                        >OK</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
              <div id="tag-box" v-if="!showInputeTags">
                <span class="chips" v-for="(chip, index) in postData.graph_tags" :key="index" @input="removeItem(chip)">
                  {{ chip }}
                  <v-icon small @click="deleteTag(chip)">cancel</v-icon>
                </span>
                <v-chip color="#e8e8e8" text-color="#444444" @click="addTag"
                  >タップで追加</v-chip
                >
              </div>
              <v-flex xs12>
                <h3>ネタバレの有無を選択してください</h3>
                <p>
                  ありにした場合「ネタバレ注意！」というタグが追加されます。
                </p>
              </v-flex>
              <v-radio-group v-model="spoiler" row>
                <v-radio label="あり" :key="1" :value="1"></v-radio>
                <v-radio label="なし" :key="0" :value="0"></v-radio>
              </v-radio-group>
            </v-layout>
            <v-card-actions>
              <v-btn
                class="black--text font-weight-bold"
                color="primary"
                dark
                small
                @click="registerGraph"
                >公開</v-btn
              >
              <v-btn
                class="black--text font-weight-bold"
                color="primary lighten-1"
                @click="saveGraph"
                small
                >非公開</v-btn
              >
            </v-card-actions>
            <v-card-actions>
              <v-btn
                class="black--text font-weight-bold"
                color="gray"
                flat
                @click="cancel"
                small
                >キャンセル</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  props: {
    graphId: {
      type: Number
    },
    title: {
      type: String
    },
    drawType: {
      type: String,
      default: ""
    },
    baseGraphId: {
      type: Number,
      default: 0
    },
    tags: {
      type: Array,
      default: () => {
        [];
      }
    },
    secretFlg: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ErrorMessage
  },
  watch: {
    tags: function() {
      this.setTags();
    },
    title: function() {
      if (!this.edit_first_title) {
        this.edit_first_title = this.title;
      }
    }
  },
  data() {
    return {
      showInputeTags: false,
      dialog: false,
      errorDialog: false,
      spoiler: 0,
      tagString: "",
      postData: {
        secret_flg: false,
        publish_flg: false,
        graph_tags: []
      },
      edit_first_title: "",
      before_title: ""
    };
  },
  mounted() {
    this.secretFlg === true ? (this.spoiler = 1) : (this.spoiler = 0);
  },
  methods: {
    setTagsForTitle() {
      // 今編集中のタイトルがpostData.graph_tagsにあるかどうか
      let index = this.postData.graph_tags.indexOf(this.title);
      // 一度タグに登録されたタイトルがpostData.graph_tagsにあるかどうか
      if (index === -1) {
        index = this.postData.graph_tags.indexOf(this.before_title);
      }
      // 編集・つくりなおし等で開かれたグラフのタイトルがpostData.graph_tagsにあるかどうか
      if (index === -1) {
        index = this.postData.graph_tags.indexOf(this.edit_first_title);
      }

      if (index !== -1) {
        this.postData.graph_tags[index] = this.title;
      } else {
        this.postData.graph_tags.unshift(this.title);
      }
      this.before_title = this.title;
    },
    setTags() {
      if (this.tags.length > 0) {
        this.postData.graph_tags = [];
        for (const key in this.tags) {
          this.postData.graph_tags.push(this.tags[key]);
        }
      }
    },
    show() {
      this.dialog = true;
      this.setTagsForTitle();
    },
    /* タグデータとネタバレデータをDB登録します */
    registerGraph() {
      this.convertToPostData();
      this.postData.publish_flg = true;
      this.$http
        .put(`/v1/graphs/publish/` + this.graphId, this.postData, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.$store.commit("setGraphTag", this.postData.graph_tags);
          this.$router.push({ name: "complete", query: { id: this.graphId } });
          this.dialog = false;
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの公開処理に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
      if (this.drawType == "template") {
        this.share();
      }
    },
    share() {
      const EP = "/v1/graphs/used/" + this.baseGraphId;
      this.$http
        .put(EP, {
          id: this.baseGraphId
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの利用回数更新に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    /* POSTできるようにタグデータとネタバレデータを変換します */
    convertToPostData() {
      // ネタバレの有無をBooleanに変換
      this.postData.secret_flg = !!this.spoiler;
      const netabare = "ネタバレ注意！";

      // ネタバレ注意タグを配列の先頭に配置
      // ネタバレありかつネタバレ注意タグがない時
      if (
        this.spoiler != 0 &&
        this.postData.graph_tags.indexOf(netabare) == -1
      ) {
        this.postData.graph_tags.unshift(netabare);
      } else if (this.spoiler == 0) {
        //ネタバレなしでネタバレ注意タグがあれば取り除く
        const idx = this.postData.graph_tags.indexOf(netabare);
        if (idx >= 0) {
          this.postData.graph_tags.splice(idx, 1);
        }
      }

      if (!this.title) {
        this.title = "タイトルなし";
        this.postData.graph_tags.unshift(this.title);
      }
    },
    saveGraph() {
      this.convertToPostData();
      this.$http
        .put(`/v1/graphs/publish/` + this.graphId, this.postData, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.$store.commit("setGraphTag", this.postData.graph_tags);
          this.$router.push({ name: "mypage" });
          this.dialog = false;
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの保存に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    addTag() {
      this.tagString = this.postData.graph_tags.join(" ");
      this.showInputeTags = true;
    },
    deleteTag(item) {
      const index = this.postData.graph_tags.indexOf(item);
      if(index === -1) {
        return false;
      }
      this.postData.graph_tags.splice(index, 1)
    },
    blurTextfield(e) {
      if (e.isComposing) {
        return false;
      }
      let tmpWords = [];
      // テキストフィールドに文字列が入っていたら、半角空白で分割する
      if (this.tagString && this.tagString.length !== 0) {
        // テキストフィールドに入っている文字列を、半角空白で分割し配列にする
        tmpWords = this.tagString.split(/( |　)+/);
      }

      // タグが10個以上登録されていたらエラー
      let spaces = this.tagString.match(/( |　)/g || []);
      if (spaces && spaces.length >= 10) {
        this.errorDialog = true;
        return false;
      }
      // tmpWordsの中に、空白のみの要素があったら削除
      tmpWords = tmpWords.filter(w => w.trim());

      // 重複しているキーワードを削除
      tmpWords = [...new Set(tmpWords)];

      this.postData.graph_tags = tmpWords;
      this.showInputeTags = false;
    },
    /* chips.itemから指定されたitemを削除します */
    removeItem(tag) {
      const chips = this.postData.graph_tags;
      const index = chips.findIndex(w => w === tag);
      if (index === -1) {
        return false;
      }
      this.postData.graph_tags.splice(index, 1);
    },
    cancel() {
      this.dialog = false;
      this.$emit("register-cancel");
    }
  }
};
</script>

<style scoped lang="scss">
#tag-box {
  margin-top: 10px;
  margin-bottom: 30px;
}

.v-input--selection-controls {
  margin-top: 0;
}

span.chips {
  background: #e0e0e0;
  color: rgba(0,0,0,0.87);
  padding: 2px 12px;
  border-radius: 28px;
  margin: 4px;
  display: inline-block;
}
</style>
